// extracted by mini-css-extract-plugin
export var alignLeft = "s_rd d_fp d_bG d_dv";
export var alignCenter = "s_bP d_fq d_bD d_dw";
export var alignRight = "s_rf d_fr d_bH d_dx";
export var customRow = "s_pb d_bD d_Z";